module.exports = __webpack_public_path__ + "assets/img/thumb-Discover-Massage-Australia-Video.cc555ddb.jpg";